var map = {
	"./basesAndBasicsRecipes.ts": 215,
	"./breakfastRecipes.ts": 874,
	"./dessertsRecipes.ts": 954,
	"./dinnersRecipes.ts": 314,
	"./mugsRecipes.ts": 63,
	"./sidesAndSnacksRecipes.ts": 425,
	"./smoothiesRecipes.ts": 642
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 878;
module.exports = webpackAsyncContext;